<template>
  <div>
    <div class="market-box">
      <div class="all-box">
        <div class="left-box">
          <div class="user-box">
            <img src="@/assets/img/kefu.png" />
            <p>{{ user.username || "用户" }}</p>

            <div class="btn1">
              <!-- <div>{{ $t("user_center.update_user_img") }}</div> -->
              <div @click="typeChange(6)">
                {{ $t("user_center.see_user_share") }}
              </div>
            </div>
          </div>
          <template v-for="(item, index) in leftMenuList">
            <div
              class="left-item-box"
              :class="{ sel: currType === item.value }"
              @click="typeChange(item.value)"
            >
              <img v-show="currType === item.value" :src="item.iconS" />
              <img v-show="currType !== item.value" :src="item.icon" />
              <p>{{ item.title }}</p>
            </div>
          </template>
        </div>
        <div class="right-box">
          <BoxContent1 v-if="currType === 1" />
          <BoxContent2 v-if="currType === 2" />
          <BoxContent3 v-if="currType === 3" />
          <BoxContent4 v-if="currType === 4" />
          <BoxContent5 v-if="currType === 5" />
          <BoxContent6 v-if="currType === 6" />
        </div>
      </div>
    </div>
    <VFooter />
    <QuestionPopup />
  </div>
</template>

<script>
import { mapState } from "vuex";
import VFooter from "@/components/footer/VFooter";
import BoxContent1 from "./components/BoxContent1";
import BoxContent2 from "./components/BoxContent2";
import BoxContent3 from "./components/BoxContent3";
import BoxContent4 from "./components/BoxContent4";
import BoxContent5 from "./components/BoxContent5";
import BoxContent6 from "./components/BoxContent6";
import QuestionPopup from "@/components/QuestionPopup/index";
export default {
  components: {
    VFooter,
    BoxContent1,
    BoxContent2,
    BoxContent3,
    BoxContent4,
    BoxContent5,
    BoxContent6,
    QuestionPopup,
  },
  computed: {
    ...mapState(["user"]),
  },
  data() {
    return {
      currType: 1,
      leftMenuList: [
        {
          value: 1,
          title: this.$t("user_center.accountManagement"),
          icon: require("@/assets/img/images/user/left1.png"),
          iconS: require("@/assets/img/images/user/left1-s.png"),
        },
        {
          value: 2,
          title: this.$t("user_center.accountSettings"),
          icon: require("@/assets/img/images/user/left2.png"),
          iconS: require("@/assets/img/images/user/left2-s.png"),
        },
        {
          value: 3,
          title: this.$t("user_center.apiManagement"),
          icon: require("@/assets/img/images/user/left3.png"),
          iconS: require("@/assets/img/images/user/left3-s.png"),
        },
        {
          value: 4,
          title: this.$t("user_center.paySettings"),
          icon: require("@/assets/img/images/user/left4.png"),
          iconS: require("@/assets/img/images/user/left4-s.png"),
        },
        {
          value: 5,
          title: this.$t("user_center.orderManagement"),
          icon: require("@/assets/img/images/user/left5.png"),
          iconS: require("@/assets/img/images/user/left5-s.png"),
        },
      ],
    };
  },
  mounted() {
    if (this.$route.query.type) this.currType = Number(this.$route.query.type);
  },
  methods: {
    typeChange(val) {
      this.currType = val;
    },
  },
};
</script>

<style lang="less" scoped>
.market-box {
  position: relative;
  background: #f5f6f7;
  padding: 60px 260px 120px 260px;
  .all-box {
    gap: 28px;
    display: flex;
    .left-box {
      padding: 40px;
      width: 420px;
      gap: 20px;
      height: fit-content;
      display: flex;
      flex-direction: column;
      background: #ffffff;
      border-radius: 22px;
      .left-item-box {
        gap: 32px;
        display: flex;
        cursor: pointer;
        padding: 12px 18px;
        align-items: center;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 22px;
        color: #2c333b;
        img {
          width: 44px;
          height: 44px;
        }
      }
      .sel {
        font-weight: 800;
        font-size: 22px;
        color: #4063ff;
        background: #e1eaff;
        border-radius: 10px 10px 10px 10px;
      }
      .user-box {
        gap: 20px;
        display: flex;
        margin-bottom: 40px;
        align-items: center;
        flex-direction: column;
        img {
          width: 136px;
          height: 136px;
          border-radius: 50%;
        }
        p {
          width: 100%;
          text-align: center;
          font-family: PingFang SC, PingFang SC;
          font-weight: bold;
          font-size: 28px;
          color: #2c333b;
          white-space: nowrap; /* 禁止换行 */
          overflow: hidden; /* 隐藏溢出内容 */
          text-overflow: ellipsis; /* 显示省略号 */
        }
        .btn1 {
          gap: 20px;
          width: 100%;
          display: flex;
          div {
            flex: 1;
            cursor: pointer;
            height: 48px;
            line-height: 48px;
            text-align: center;
            background: #ffffff;
            border-radius: 6px 6px 6px 6px;
            border: 1px solid #4063ff;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 22px;
            color: #4063ff;
          }
        }
      }
    }
    .right-box {
      flex: 1;
      overflow: hidden;
    }
  }
}
</style>
